import React, { useState } from 'react';
import '../App.css';
import { useHistory, useLocation } from 'react-router-dom';
import { Form, FormGroup, Button, Input } from 'reactstrap';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import MyLoader from './util/loader';
import MyStorage from './util/storage';
import Api from './api/api';
import showToast from './util/toast';
import { ToastContainer } from 'react-toastify';
import MyPopup from './util/popup';

const SendEmail = () => {
    const history = useHistory()
    const location = useLocation()

    let email = ''
    if (location.state) {
        if (location.state.user) {
            if (location.state.user != null) {
                email = location.state.user.email
            }
        }
    }

    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const [recepients, setRecepients] = useState(email);
    const [sendToAll, setSendToAll] = useState(false);
    const [title, setTitle] = useState('');
    const [loader, setLoader] = useState(false);

    const onEditorStateChange = (editorState) => {
        console.log(JSON.stringify(editorState));
        setEditorState(editorState)
    };

    const sendMail = () => {
        // body = draftToHtml(convertToRaw(editorState.getCurrentContent()))
        if (!sendToAll && recepients === '') {
            showToast('error', 'Please select recepients!')
            return
        }
        if (title === '') {
            showToast('error', 'Please enter title!')
            return
        }
        let body = draftToHtml(convertToRaw(editorState.getCurrentContent()))
        console.log('body: ' + body);
        if (body.length < 10) {
            showToast('error', 'Please enter body!')
            return
        }

        setLoader(true);
        Api.sendEmail(sendToAll ? 'all' : recepients, title, body,
            (response) => {
                setLoader(false);
                if (response.status === 'success') {
                    showToast('success', 'Email Sent!')
                    // history.goBack()
                }
            },
            (error) => {
                setLoader(false);
                showToast('error', '' + error)
            });
    };

    return (
        <div className='main'>
            <div className='titlebar' style={{ backgroundColor: '#f2f2f2', padding: 10, margin: -15 }}>
                <div style={{ color: 'blue' }}>
                    Send Email
                </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: 15 }}>
                <Form className="form" style={{ width: 600, marginTop: 20, backgroundColor: '#f2f2f2' }}>
                    <FormGroup style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <input
                                type="checkbox"
                                checked={sendToAll}
                                onChange={() => {
                                    setSendToAll(!sendToAll)
                                }}
                            />
                            <div style={{ marginLeft: 10 }}>
                                Send to all
                            </div>
                        </div>
                    </FormGroup>
                    {/* <div style={{ marginTop: 10, color:'gray' }}>
                        Or Choose
                    </div> */}
                    {sendToAll ?
                        null
                        :
                        <FormGroup style={{ marginTop: 10, display: 'flex', alignItems: 'center' }}>
                            <Input
                                type='text'
                                placeholder='Recepients (comma separated)'
                                value={recepients}
                                onChange={(event) => {
                                    setRecepients(event.target.value)
                                }} />
                            <MyPopup
                                collect='email'
                                title={'Select Users'}
                                models={MyStorage.getAllUsers()}
                                onDone={(users) => { // label, value (email)
                                    console.log('selected: ' + JSON.stringify(users));
                                    let emails = ''
                                    for (let i = 0; i < users.length; i++) {
                                        const user = users[i];
                                        if (i < users.length - 1)
                                            emails = emails + user.value + ','
                                        else
                                            emails = emails + user.value
                                    }
                                    setRecepients(emails)
                                }}
                                button={
                                    <Button
                                        style={{ marginLeft: 10, fontSize: 16 }}
                                        className='btn-block btn-dark'
                                        onClick={() => {
                                            //
                                        }}>
                                        Choose
                                    </Button>
                                } />
                        </FormGroup>
                    }

                    <FormGroup style={{ marginTop: 10 }}>
                        <Input
                            type='text'
                            placeholder='Email Title'
                            value={title}
                            onChange={(event) => {
                                setTitle(event.target.value)
                            }} />
                    </FormGroup>
                    <div style={{ color: 'gray', marginTop: 10, marginBottom: 5 }}>Email Body</div>
                    <Editor
                        editorStyle={{ backgroundColor: 'white', paddingLeft: 10, paddingRight: 10, height: 150 }}
                        editorState={editorState}
                        toolbarClassName="toolbarClassName"
                        wrapperClassName="wrapperClassName"
                        editorClassName="editorClassName"
                        onEditorStateChange={onEditorStateChange}
                    />
                    {/* <textarea
                        disabled
                        style={{height:200}}
                        value={draftToHtml(convertToRaw(editorState.getCurrentContent()))}/> */}
                    <Button
                        style={{ marginTop: 20, fontSize: 16 }}
                        className='btn-block btn-dark'
                        onClick={() => {
                            sendMail()
                        }}>
                        Send Email
                    </Button>
                </Form>
            </div>
            <MyLoader loader={loader} />
            <div>
                <ToastContainer />
            </div>
        </div>
    );
}

export default SendEmail;